{
  "eyebrow": "Estás dentro",
  "title": "Bem-vindo ao Done-it, {{company}}.",
  "titleGeneric": "Bem-vindo ao Done-it.",
  "sub": "A tua avaliação de 30 dias do {{plan}} está ativa. Três próximos passos.",
  "subGeneric": "A sua conta está ativa. Três coisas a fazer a seguir.",
  "next1": {
    "title": "Descarrega a app móvel",
    "desc": "Envia ao teu equipa o link de instalação por SMS ou email.",
    "cta": "Enviar link de convite"
  },
  "next2": {
    "title": "Convida a tua equipa",
    "desc": "Importa colaboradores em lote por CSV ou adiciona-os um a um.",
    "cta": "Abrir administração"
  },
  "next3": {
    "title": "Vê um tour de 4 minutos",
    "desc": "Aprende a configurar o primeiro projeto e os locais.",
    "cta": "Ver vídeo"
  },
  "cta": "Ir para o painel",
  "receipt": "Um recibo e email de boas-vindas estão a caminho de {{email}}.",
  "receiptGeneric": "Um recibo e email de boas-vindas estão a caminho.",
  "fallbacks": {
    "company": "a tua empresa",
    "plan": "o teu plano",
    "inbox": "a tua caixa de entrada"
  },
  "stores": {
    "appStore": "App Store",
    "googlePlay": "Google Play"
  },
  "subFree": "A sua conta {{plan}} está ativa — gratuita para sempre. Três coisas a fazer a seguir."
}
